<mat-sidenav-container class="sidenav-container">
  <mat-sidenav mode="side" opened class="sidenav">

    <mat-nav-list> 
      <mat-list-item class="nav-item"><a href="#" class="nav-link">🏠 Home</a></mat-list-item>

      <h4 class="nav-title">🏗️ Foundation Settlement {{cRoles == 'NMAFSM.Admin' ? 'Admin':''}}</h4>


      <!-- foundation -->
      @if(cRoles == 'NMAFSM.Admin' || cRoles == 'NMAFSM.ReportsAndData') {
      <mat-list-item><a routerLink="/foundation/home" class="nav-link"
          routerLinkActive="active"><span>&#8594;</span>Foundation Home</a></mat-list-item>
      } @else if(cRoles == 'NMAFSM.ReportViewer') {

      <mat-list-item><a routerLink="/reporting" class="nav-link"
          routerLinkActive="active"><span>&#8594;</span>Foundation Home</a></mat-list-item>

      }@else{
      <mat-list-item><a class="nav-link" routerLinkActive="active"><span>&#8594;</span>Foundation
          Home</a></mat-list-item>
      }

      @if(cPath !== 'reporting'){

      <!-- Elevation Data -->
      @if(this.commonService.checkPermission(['NMAFSM.Admin','NMAFSM.DataEntry', 'NMAFSM.ReportsAndData'])){
      <mat-list-item><a routerLink="/foundation/elevation" class="nav-link"
          routerLinkActive="active"><span>&#8594;</span>{{ isElevation ? 'Data Entry':'Elevation Data'
          }}</a></mat-list-item>
      }

      @if(cPath !== 'foundation' || !isElevation) {
      <!-- Management -->
      @if(this.commonService.checkPermission(['NMAFSM.Admin'])){

      <h4 class="nav-title">🛠️ Management</h4>
      <mat-list-item><a routerLink="/management/foundation" class="nav-link" routerLinkActive="active"
        [class.active-secondary]="cPath === 'management' && (
          router.url.includes('/management/add-foundation')  || 
          router.url.includes('/management/delete-foundation')  || 
          router.url.includes('/management/sequence/') ||
          router.url.includes('/management/add-sequence/') ||
          router.url.includes('/management/delete-sequence/') || 
          router.url.includes('/management/adjacent-center-admin/') ||
          router.url.includes('/management/add-adjacent-center-admin/') 
        )"
        
        ><span>&#8594;</span>Foundation Admin</a></mat-list-item>
      <mat-list-item>
        
        <a routerLink="/management/special-relationships" routerLinkActive="active" class="nav-link" 
        [class.active-secondary]="cPath === 'management' && (router.url.includes('/management/add-relationship') )"
        
        ><span>&#8594;</span>Special Relationships Admin</a></mat-list-item>
        <!-- [class]="{'active':cPath === 'management' && (router.url.includes('/management/add-relationship') || router.url.includes('/management/special-relationships'))}"><span>&#8594;</span>Special Relationships Admin</a></mat-list-item> -->

      <mat-list-item><a routerLink="/management/user-privileges" routerLinkActive="active" class="nav-link"><span>&#8594;</span>User Privileges Admin</a></mat-list-item>

      <mat-list-item><a routerLink="/management/sequence-type" routerLinkActive="active" class="nav-link"><span>&#8594;</span>Sequence Type Admin</a></mat-list-item>
      <mat-list-item><a routerLink="/management/elevation" routerLinkActive="active" class="nav-link"><span>&#8594;</span>Elevation Data Admin</a></mat-list-item>
      <mat-list-item><a routerLink="/management/remarks" routerLinkActive="active" class="nav-link"><span>&#8594;</span>          Remarks Data Admin</a></mat-list-item>
      }
      }
      }

      @if(cPath !== 'foundation' || !isElevation) {
      <!-- Reporting -->
      @if(this.commonService.checkPermission(['NMAFSM.Admin','NMAFSM.ReportViewer','NMAFSM.ReportsAndData'])){

      @if(cPath !== 'reporting'){
      <h4 class="nav-title">📊 Reporting</h4>
      <mat-list-item> <a routerLink="/reporting" routerLinkActive="active" class="nav-link"><span>&#8594;</span> Reporting Home</a></mat-list-item>
      } @else {

    <h4 class="nav-title">📊 Report</h4>
    <mat-list-item> <a routerLink="/reporting/report/elvDataByFoundation" routerLinkActive="active" class="nav-link"><span>&#8594;</span> Elv Data by Foundation</a></mat-list-item>
    <mat-list-item> <a routerLink="/reporting/elv-data-by-sequence" routerLinkActive="active" class="nav-link"><span>&#8594;</span> Elv Data by Sequence</a></mat-list-item>
    <mat-list-item> <a routerLink="/reporting/report/overallSettlementReport" routerLinkActive="active" class="nav-link"><span>&#8594;</span> Overall Settlement</a></mat-list-item>
    <mat-list-item> <a routerLink="/reporting/report/cteDiffSettlementReport" routerLinkActive="active" class="nav-link"><span>&#8594;</span> CTE Diff Settlement</a></mat-list-item>
    <mat-list-item> <a routerLink="/reporting/report/ctcDiffSettlementReport" routerLinkActive="active" class="nav-link"><span>&#8594;</span> CTC Diff Settlement</a></mat-list-item>
    <mat-list-item> <a routerLink="/reporting/report/rspDiffSettlement" routerLinkActive="active" class="nav-link"><span>&#8594;</span> RSP Diff Settlement</a></mat-list-item>
    <mat-list-item> <a routerLink="/reporting/report/remarksDataReport" routerLinkActive="active" class="nav-link"><span>&#8594;</span> Remarks Data</a></mat-list-item>
    <mat-list-item> <a routerLink="/reporting/report/maxDifferentialWithinFndReport" routerLinkActive="active" class="nav-link"><span>&#8594;</span> Max Differential Within Fnd</a></mat-list-item>

      <h4 class="nav-title">📊 Flagged Reports</h4>      
      <mat-list-item> <a routerLink="/reporting/flagged-reports/ElvData2WeeksLate" routerLinkActive="active" class="nav-link"><span>&#8594;</span> Elv Data 2 Weeks Late</a></mat-list-item>
      <mat-list-item> <a routerLink="/reporting/flagged-reports/Overall" routerLinkActive="active" class="nav-link"><span>&#8594;</span>Overall Flagged</a></mat-list-item>
      <mat-list-item> <a routerLink="/reporting/flagged-reports/CTEDifferential" routerLinkActive="active" class="nav-link"><span>&#8594;</span> CTE Differential Flagged</a></mat-list-item>
      <mat-list-item> <a routerLink="/reporting/flagged-reports/CTCDifferential" routerLinkActive="active" class="nav-link"><span>&#8594;</span> CTC Differential Flagged</a></mat-list-item>
      <mat-list-item> <a routerLink="/reporting/flagged-reports/RSPDifferential" routerLinkActive="active" class="nav-link"><span>&#8594;</span> RSP Differential Flagged</a></mat-list-item>
      <mat-list-item> <a routerLink="/reporting/flagged-reports/MaxDiffWithinFnd" routerLinkActive="active" class="nav-link"><span>&#8594;</span> Max Diff Within Fnd Flagged</a></mat-list-item>
      
      }
      }
      }

    </mat-nav-list>


  </mat-sidenav>
  <mat-sidenav-content>
    <!-- Main content goes here -->
    <div class="content-block">

      <router-outlet></router-outlet>

    </div>
  </mat-sidenav-content>
</mat-sidenav-container>